/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { UserProfileValidationDialogComponent } from './user-profile-validation-dialog.component';

export const userProfileValidationDialogRoute = createDialogRoute({
  component: UserProfileValidationDialogComponent,
  config: { disableClose: true },
});
